import axios from "axios";
import store from "../../../store";
import { API_ROOT, ORDER_API_ROOT, COLLECTIONS } from "../../urls";

// **********************************************
export const addRecord = obj => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/create_rec`;
  return axios
    .post(url, obj)
    .then(res => {
      const data = res.data;
    })
    .catch(error => {});
};

// **********************************************
export const getWholeRecord = recordId => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${recordId}/get_whole_rec`;

  return new Promise(resolve => {
    axios.get(url).then(res => {
      const patientData = res.data;
      resolve(patientData);
    });
  });
};
export const get_whole_rec_by_account = username => {
  /* Get whole record from root with children embedded
   */
  const url = `${API_ROOT}/${username}/get_rec_by_acct`;
  return new Promise(resolve => {
    axios.get(url).then(res => {
      const record = res.data;
      resolve(record);
    });
  });
};

export const fetchRecords = () => {
  // A pattern of --all-- returns all records.
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/--all--/get_recs`;

  return new Promise(resolve => {
    axios.get(url).then(res => {
      const names = res.data;
      resolve(names);
    });
  });
};

export const updateWholeRec = obj => {
  /* Update a medical record
     The record specified by its root id (in obj)  is replaced by obj.

     Returns the replaced tree. 
  */
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/update_whole_rec`;
  return new Promise(resolve => {
    axios
      .post(url, obj)
      .then(res => {
        const data = res.data;
        resolve(data);
      })
      .catch(error => {
        store.dispatch("addNotification", {
          errorBody: error.response.data,
          type: "errorMessage",
          message: `An error with status code ${error.response.status} has occured`
        });
      });
  });
};

export const updateRec = obj => {
  /* Update a medical record
     params are the medical record _id and the object to add or update.
     Obj can also be an array of children
     to add: object must contain it's parent's id but not its own _id.
     to update: object must contain it's parent and its own _id.
     same rules apply to an array of objects.
     Objects cannot be composites. In other words a parent and its children
     cannot be updated with one call. They must be separated.
     Returns the entire record.
  */

  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/update_rec`;
  return new Promise(resolve => {
    axios
      .post(url, obj)
      .then(res => {
        const data = res.data;
        resolve(data);
      })
      .catch(error => {
        console.error(error);
        console.debug(error);
        console.dir(error);
        resolve(error);
      });
  });
};

export const FetchPeriodicDateRange = (recordId, dateRangeArray) => {
  // A pattern of --all-- returns all records.
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/fetch_periodic_range`;

  return new Promise(resolve => {
    axios
      .post(url, {
        rec_id: recordId,
        date_range: dateRangeArray
      })
      .then(res => {
        resolve(res);
      });
  });
};

export const FetchValidDates = recordId => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/${recordId}/fetch_valid_dates`;

  return new Promise(resolve => {
    axios.get(url).then(res => {
      resolve(res);
    });
  });
};

export const GetNotificationsForSpecificRecord = recordId => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order_notification/${recordId}`;

  return new Promise(resolve => {
    axios.get(url).then(res => resolve(res.data));
  });
};
export const UpdateNotificationForSpecificRecord = notification => {
  const url = `${API_ROOT}/${COLLECTIONS.RECORDS}/order_notification`;

  return new Promise(resolve => {
    axios.put(url, notification).then(res => resolve(res.data));
  });
};
export const getNewNotificationProto = () => {
  const url = `${ORDER_API_ROOT}/api/get-notify-proto/`;
  return new Promise(resolve => {
    axios.get(url).then(res => resolve(res.data));
  });
};
export const postNewNotificationProto = notification => {
  const url = `${ORDER_API_ROOT}/api/notify/${COLLECTIONS.RECORDS}/`;
  return new Promise(resolve => {
    axios.post(url, notification).then(res => resolve(res.data));
  });
};
export const updateNotification = notification => {
  const url = `${ORDER_API_ROOT}/api/notify/${COLLECTIONS.RECORDS}/`;
  return new Promise(resolve => {
    axios.put(url, notification).then(res => resolve(res.data));
  });
};
export const fetchExistingNotifications = orderId => {
  const url = `${ORDER_API_ROOT}/api/notify/${COLLECTIONS.RECORDS}/${orderId}/`;
  return new Promise(resolve => {
    axios.get(url).then(res => resolve(res.data));
  });
};
export const deleteNotification = (orderId, notificationId) => {
  const url = `${ORDER_API_ROOT}/api/notify/${COLLECTIONS.RECORDS}/${orderId}/${notificationId}`;
  return new Promise(resolve => {
    axios.delete(url).then(res => resolve(res.data));
  });
};
